// import React from 'react';

// const Footer = () => {
//   return (
//     <footer className="bg-primary text-white py-6 px-4 text-center">
//       <p>&copy; 2025 Tiranga Express. All rights reserved.</p>
//     </footer>
//   );
// };

// export default Footer;

// import React from "react";
// import { motion } from "framer-motion";
// import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";

// const Footer = () => {
//   return (
//     <footer className="bg-[#004182] text-white pt-12 pb-6 px-6 relative overflow-hidden">
//       {/* Top wave divider */}
//       <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180">
//         <svg
//           className="relative block w-full h-12"
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 1200 120"
//           preserveAspectRatio="none"
//         >
//           <path
//             d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z"
//             className="fill-[#F5F7FA]"
//           ></path>
//         </svg>
//       </div>

//       {/* Footer content */}
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 mt-6 relative z-10">
//         {/* About Tiranga Express */}
//         <motion.div
//           whileHover={{ y: -5 }}
//           transition={{ type: "spring", stiffness: 120 }}
//         >
//           <h2 className="text-2xl font-bold text-secondary mb-3">
//             Tiranga Express
//           </h2>
//           <p className="text-sm text-gray-200 leading-relaxed">
//             Your trusted logistics partner for safe, reliable, and cost-effective
//             moving and transportation solutions across India. We make relocation
//             simple, fast, and secure for every customer.
//           </p>
//         </motion.div>

//         {/* Quick Links */}
//         <motion.div
//           whileHover={{ y: -5 }}
//           transition={{ type: "spring", stiffness: 120 }}
//         >
//           <h3 className="text-xl font-semibold text-secondary mb-3">
//             Quick Links
//           </h3>
//           <ul className="space-y-2 text-sm">
//             <li>
//               <a href="/" className="hover:text-secondary transition">
//                 Home
//               </a>
//             </li>
//             <li>
//               <a href="/about" className="hover:text-secondary transition">
//                 About Us
//               </a>
//             </li>
//             <li>
//               <a href="/services" className="hover:text-secondary transition">
//                 Services
//               </a>
//             </li>
//             <li>
//               <a href="/partners" className="hover:text-secondary transition">
//                 Partners
//               </a>
//             </li>
//             <li>
//               <a href="/contact" className="hover:text-secondary transition">
//                 Contact
//               </a>
//             </li>
//           </ul>
//         </motion.div>

//         {/* Our Services */}
//         <motion.div
//           whileHover={{ y: -5 }}
//           transition={{ type: "spring", stiffness: 120 }}
//         >
//           <h3 className="text-xl font-semibold text-secondary mb-3">
//             Our Services
//           </h3>
//           <ul className="space-y-2 text-sm">
//             <li>Packers & Movers</li>
//             <li>Car Transportation</li>
//             <li>Warehouse & Cargo</li>
//             <li>International Shipping</li>
//             <li>Pet Relocation</li>
//           </ul>
//         </motion.div>

//         {/* Contact Info */}
//         <motion.div
//           whileHover={{ y: -5 }}
//           transition={{ type: "spring", stiffness: 120 }}
//         >
//           <h3 className="text-xl font-semibold text-secondary mb-3">
//             Contact Us
//           </h3>
//           <p className="text-sm text-gray-200 mb-1">
//             📞 +91 95604 79500
//           </p>
//           <p className="text-sm text-gray-200 mb-1">
//             ✉️ support@tirangaexpress.in
//           </p>
//           <p className="text-sm text-gray-200">
//             📍 New Delhi, India
//           </p>

//           <div className="flex space-x-4 mt-4">
//             <a
//               href="#"
//               className="bg-secondary p-2 rounded-full text-[#004182] hover:bg-accent hover:text-white transition"
//             >
//               <FaFacebookF />
//             </a>
//             <a
//               href="#"
//               className="bg-secondary p-2 rounded-full text-[#004182] hover:bg-accent hover:text-white transition"
//             >
//               <FaInstagram />
//             </a>
//             <a
//               href="#"
//               className="bg-secondary p-2 rounded-full text-[#004182] hover:bg-accent hover:text-white transition"
//             >
//               <FaLinkedinIn />
//             </a>
//             <a
//               href="#"
//               className="bg-secondary p-2 rounded-full text-[#004182] hover:bg-accent hover:text-white transition"
//             >
//               <FaTwitter />
//             </a>
//           </div>
//         </motion.div>
//       </div>

//       {/* Bottom section */}
//       <div className="mt-10 border-t border-gray-600 pt-4 text-center text-sm text-gray-300">
//         <p>
//           © {new Date().getFullYear()} <span className="text-secondary font-semibold">Tiranga Express</span>.  
//           All Rights Reserved.
//         </p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import React from "react";
import { motion } from "framer-motion";
import {
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  Phone,
  Mail,
  MapPin,
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#004182] text-white pt-12 pb-6 px-6 relative overflow-hidden">
      {/* Top Wave Divider */}
      {/* <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-360">
        <svg
          className="relative block w-full h-12"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z"
            className="fill-[#F5F7FA]"
          ></path>
        </svg>
      </div> */}

      {/* Main Content */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 mt-6 relative z-10">
        {/* About Section */}
        <motion.div
          whileHover={{ y: -5 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          <h2 className="text-2xl font-bold text-white mb-3">
            Tiranga Express
          </h2>
          <p className="text-sm text-gray-200 leading-relaxed">
            Your trusted logistics partner for safe, reliable, and cost-effective
            moving and transportation solutions across India. We make relocation
            simple, fast, and secure for every customer.
          </p>
        </motion.div>

        {/* Quick Links */}
        <motion.div
          whileHover={{ y: -5 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          <h3 className="text-xl font-semibold text-white mb-3">
            Quick Links
          </h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="/" className="hover:text-white transition">
                Home
              </a>
            </li>
            <li>
              <a href="/about" className="hover:text-white transition">
                About Us
              </a>
            </li>
            <li>
              <a href="/services" className="hover:text-white transition">
                Services
              </a>
            </li>
            <li>
              <a href="/partners" className="hover:text-white transition">
                Partners
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:text-white transition">
                Contact
              </a>
            </li>
          </ul>
        </motion.div>

        {/* Services */}
        <motion.div
          whileHover={{ y: -5 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          <h3 className="text-xl font-semibold text-white mb-3">
            Our Services
          </h3>
          <ul className="space-y-2 text-sm">
            <li>🚛 Packers & Movers</li>
            <li>🚗 Car Transportation</li>
            <li>🏬 Warehouse & Cargo</li>
            <li>✈️ International Shipping</li>
            <li>🐶 Pet Relocation</li>
          </ul>
        </motion.div>

        {/* Contact Info */}
        <motion.div
          whileHover={{ y: -5 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          <h3 className="text-xl font-semibold text-white mb-3">
            Contact Us
          </h3>
          <div className="space-y-2 text-sm text-gray-200">
            <p className="flex items-center gap-2">
              <Phone size={16} /> +91 95604 79500
            </p>
            <p className="flex items-center gap-2">
              <Mail size={16} /> support@tirangaexpress.in
            </p>
            <p className="flex items-center gap-2">
              <MapPin size={16} /> New Delhi, India
            </p>
          </div>

          <div className="flex space-x-4 mt-4">
            <a
              href="#"
              className="bg-white p-2 rounded-full text-[#004182] hover:bg-accent hover:text-white transition"
            >
              <Facebook size={18} />
            </a>
            <a
              href="#"
              className="bg-white p-2 rounded-full text-[#004182] hover:bg-accent hover:text-white transition"
            >
              <Instagram size={18} />
            </a>
            <a
              href="#"
              className="bg-white p-2 rounded-full text-[#004182] hover:bg-accent hover:text-white transition"
            >
              <Linkedin size={18} />
            </a>
            <a
              href="#"
              className="bg-white p-2 rounded-full text-[#004182] hover:bg-accent hover:text-white transition"
            >
              <Twitter size={18} />
            </a>
          </div>
        </motion.div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-10 border-t border-gray-600 pt-4 text-center text-sm text-gray-300">
        <p>
          © {new Date().getFullYear()}{" "}
          <span className="text-white font-semibold">Tiranga Express</span>.
          All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
